var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "row justify-content-end" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "col-2" }, [
          _c("div", { staticClass: "btn btn-group btn-group-lg" }, [
            _c(
              "button",
              {
                directives: [
                  {
                    name: "b-toggle",
                    rawName: "v-b-toggle.searchEwbs",
                    modifiers: { searchEwbs: true }
                  }
                ],
                staticClass: "btn btn-secondary"
              },
              [
                _c(
                  "i",
                  {
                    staticClass: "float-right fa fa-search",
                    staticStyle: { cursor: "pointer" }
                  },
                  [_vm._v(" ")]
                )
              ]
            )
          ])
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col" },
        [
          _c(
            "b-collapse",
            { staticClass: "mt-1", attrs: { id: "searchEwbs", visible: "" } },
            [
              _c("b-card", { staticStyle: { "background-color": "#F9F9F9" } }, [
                _c("div", { staticClass: "form-row justify-content-between" }, [
                  _c("div", { staticClass: "col-1" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_c("strong", [_vm._v("From Date")])]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("date-picker", {
                          attrs: { config: _vm.optionsDt },
                          model: {
                            value: _vm.generatedDateRangeFrom,
                            callback: function($$v) {
                              _vm.generatedDateRangeFrom = $$v
                            },
                            expression: "generatedDateRangeFrom"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-1" }, [
                    _c(
                      "div",
                      { staticClass: "form-group" },
                      [
                        _c("label", [_c("strong", [_vm._v("To Date")])]),
                        _vm._v(" "),
                        _c("br"),
                        _vm._v(" "),
                        _c("date-picker", {
                          attrs: { config: _vm.optionsDt },
                          model: {
                            value: _vm.generatedDateRangeTo,
                            callback: function($$v) {
                              _vm.generatedDateRangeTo = $$v
                            },
                            expression: "generatedDateRangeTo"
                          }
                        })
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2 ml-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", [_c("strong", [_vm._v("Type")])]),
                      _vm._v(" "),
                      _c("br"),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.ewbType,
                              expression: "ewbType"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "type",
                            id: "incoming",
                            value: "consigneeGst"
                          },
                          domProps: {
                            checked: _vm._q(_vm.ewbType, "consigneeGst")
                          },
                          on: {
                            change: function($event) {
                              _vm.ewbType = "consigneeGst"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "incoming" }
                          },
                          [_vm._v("Incoming EWaybills")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "form-check" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.ewbType,
                              expression: "ewbType"
                            }
                          ],
                          staticClass: "form-check-input",
                          attrs: {
                            type: "radio",
                            name: "type",
                            id: "outgoing",
                            value: "consignorGst"
                          },
                          domProps: {
                            checked: _vm._q(_vm.ewbType, "consignorGst")
                          },
                          on: {
                            change: function($event) {
                              _vm.ewbType = "consignorGst"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "label",
                          {
                            staticClass: "form-check-label",
                            attrs: { for: "outgoing" }
                          },
                          [_vm._v("Outgoing EWaybills")]
                        )
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { attrs: { for: "creds" } }, [
                        _c("strong", [_vm._v("States")])
                      ]),
                      _vm._v(" "),
                      _c(
                        "select",
                        {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.states,
                              expression: "states"
                            }
                          ],
                          staticClass: "form-control",
                          attrs: { multiple: "", id: "creds" },
                          on: {
                            change: function($event) {
                              var $$selectedVal = Array.prototype.filter
                                .call($event.target.options, function(o) {
                                  return o.selected
                                })
                                .map(function(o) {
                                  var val = "_value" in o ? o._value : o.value
                                  return val
                                })
                              _vm.states = $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            }
                          }
                        },
                        _vm._l(_vm.creds, function(c) {
                          return _c(
                            "option",
                            { key: c.id, domProps: { value: c.gstNumber } },
                            [
                              _vm._v(
                                _vm._s(c.state) +
                                  " (" +
                                  _vm._s(c.gstNumber) +
                                  ")"
                              )
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-1" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "mt-5" }),
                      _vm._v(" "),
                      _c(
                        "button",
                        {
                          staticClass: "btn btn-primary",
                          attrs: { type: "submit" },
                          on: { click: _vm.getReport }
                        },
                        [
                          _c("i", { staticClass: "fa fa-eye" }),
                          _vm._v(" View Report")
                        ]
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "col-2" }, [
                    _c("div", { staticClass: "form-group" }, [
                      _c("label", { staticClass: "mt-3" }),
                      _vm._v(" "),
                      _c(
                        "form",
                        {
                          attrs: { action: _vm.csvDownloadUrl, method: "post" }
                        },
                        [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.searchAsJson,
                                expression: "searchAsJson"
                              }
                            ],
                            attrs: { type: "hidden", name: "json" },
                            domProps: { value: _vm.searchAsJson },
                            on: {
                              input: function($event) {
                                if ($event.target.composing) {
                                  return
                                }
                                _vm.searchAsJson = $event.target.value
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-info",
                              attrs: { type: "submit" }
                            },
                            [
                              _c("i", { staticClass: "fa fa-download" }),
                              _vm._v(" Download Excel\n                    ")
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c("br"),
    _vm._v(" "),
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12" },
        [
          _c("table", { staticClass: "table table-hover" }, [
            _vm._m(1),
            _vm._v(" "),
            _c(
              "tbody",
              _vm._l(_vm.ewbs, function(e) {
                return _c(
                  "tr",
                  {
                    key: e.id,
                    class: _vm.tblClass(e),
                    staticStyle: { cursor: "pointer" }
                  },
                  [
                    _c("td", [
                      _vm._v(
                        "\n              " + _vm._s(e.ewb) + "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v("\n              " + _vm._s(e.invoiceNo) + " "),
                      _c("br"),
                      _vm._v(
                        "\n              " +
                          _vm._s(_vm._f("date")(e.invoiceDt)) +
                          " "
                      ),
                      _c("br"),
                      _vm._v(" "),
                      _c("i", { staticClass: "fal fa-rupee-sign" }),
                      _vm._v(" " + _vm._s(e.invoiceVal) + "\n            ")
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " +
                          _vm._s(e.consignorGst) +
                          "\n              "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              " +
                          _vm._s(e.consigneeGst) +
                          "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n              " + _vm._s(e.transporterId) + " "
                      ),
                      _c("br"),
                      _vm._v(
                        "\n              " + _vm._s(e.awb) + "\n            "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "div",
                        { staticClass: "btn-group btn-group-md mt-3" },
                        [
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-modal",
                                  rawName: "v-b-modal.detView",
                                  modifiers: { detView: true }
                                },
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "btn btn-info",
                              attrs: { title: "View EWaybill" },
                              on: {
                                click: function($event) {
                                  return _vm.selectedEWB(e, $event)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-eye" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "btn btn-danger",
                              attrs: {
                                title: "Cancel EWaybill",
                                disabled: e.cancelled === true
                              },
                              on: {
                                click: function($event) {
                                  return _vm.cancelEWaybill(e, $event)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-times" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "btn btn-primary",
                              attrs: { title: "Update Part-B" },
                              on: {
                                click: function($event) {
                                  return _vm.updatePartB(e, $event)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-truck" })]
                          ),
                          _vm._v(" "),
                          _c(
                            "button",
                            {
                              directives: [
                                {
                                  name: "b-tooltip",
                                  rawName: "v-b-tooltip.hover",
                                  modifiers: { hover: true }
                                }
                              ],
                              staticClass: "btn btn-secondary",
                              attrs: { title: "Change Transporter" },
                              on: {
                                click: function($event) {
                                  return _vm.changeTransporter(e, $event)
                                }
                              }
                            },
                            [_c("i", { staticClass: "fa fa-person-carry" })]
                          )
                        ]
                      )
                    ])
                  ]
                )
              }),
              0
            )
          ]),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "detView",
                title: "E-Waybill Details",
                size: "lg",
                centered: ""
              }
            },
            [
              _c("basic-e-w-b-details", {
                attrs: { ewaybill: _vm.selectedEWaybill }
              }),
              _vm._v(" "),
              _c("h4", { staticClass: "form-head" }, [_vm._v("History")]),
              _vm._v(" "),
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("h5", [_vm._v("Part-B History")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-group" },
                    _vm._l(_vm.partBHistory, function(h) {
                      return _c(
                        "li",
                        { key: h.id, staticClass: "list-group-item" },
                        [
                          _vm._v(
                            "\n                  " +
                              _vm._s(_vm._f("datetime")(h.date)) +
                              " @ " +
                              _vm._s(h.location) +
                              "\n                "
                          )
                        ]
                      )
                    }),
                    0
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c("h5", [_vm._v("Docket History")]),
                  _vm._v(" "),
                  _c(
                    "ul",
                    { staticClass: "list-group" },
                    _vm._l(_vm.docketHistory, function(h) {
                      return h.date
                        ? _c(
                            "li",
                            { key: h.id, staticClass: "list-group-item" },
                            [
                              _vm._v(
                                "\n                  " +
                                  _vm._s(_vm._f("datetime")(h.date)) +
                                  " @ " +
                                  _vm._s(h.location) +
                                  "\n                "
                              )
                            ]
                          )
                        : _vm._e()
                    }),
                    0
                  )
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-modal",
            {
              attrs: {
                id: "podView",
                title: "Docket POD",
                size: "lg",
                centered: ""
              }
            },
            [
              _c("basic-e-w-b-details", {
                attrs: { ewaybill: _vm.selectedEWaybill }
              }),
              _vm._v(" "),
              _c("h4", { staticClass: "form-head" }, [_vm._v("POD")]),
              _vm._v(" "),
              _c("div", { staticClass: "row justify-content-center" }, [
                _c("div", { staticClass: "col-10" }, [
                  _c("img", {
                    attrs: { src: _vm.selectedEWaybill.podUrl, alt: "POD" }
                  })
                ])
              ])
            ],
            1
          ),
          _vm._v(" "),
          _vm.showCancelDialog && _vm.canCancel
            ? _c("cancel-e-w-b", {
                attrs: {
                  credential: _vm.credential,
                  ewaybill: _vm.eWaybillToCancel
                },
                on: {
                  dialogClosed: _vm.cancelDialogClosed,
                  cancelComplete: _vm.cancelComplete
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showPartBUpdateDialog
            ? _c("update-part-b", {
                attrs: {
                  credential: _vm.credential,
                  ewaybill: _vm.eWaybillToUpdate
                },
                on: {
                  dialogClosed: _vm.updatePartBDialogClosed,
                  cancelComplete: _vm.updateComplete
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.showChangeTransporterDialog
            ? _c("change-transporter", {
                attrs: {
                  credential: _vm.credential,
                  ewaybill: _vm.eWaybillToChange
                },
                on: {
                  dialogClosed: _vm.changeTransporterDialogClosed,
                  cancelComplete: _vm.changeComplete
                }
              })
            : _vm._e()
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col" }, [
      _c("h4", { staticClass: "form-head" }, [_vm._v("Reports")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", { staticClass: "thead-light" }, [
      _c("tr", [
        _c("th", [_vm._v("EWB No & Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Doc No & Date")]),
        _vm._v(" "),
        _c("th", [_vm._v("Consignor & Consignee")]),
        _vm._v(" "),
        _c("th", [_vm._v("Transporter")]),
        _vm._v(" "),
        _c("th", [_vm._v(" ")])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-7f4de293", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7f4de293","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ReportPage.vue
// module id = null
// module chunks = 